import React from 'react';
import { CONTACT, HOURS, SOCIAL_MEDIA } from '../../constants/campConfig';

const Footer = () => {
  return (
    <div>
      <footer className="footer">
        <div className="container is-fluid">
          <div className="columns">
            <div className="column is-4">
              <h5 className="title is-5">Contact</h5>
              <dl className="no-style">
                <li><strong>Address:</strong><span
                  className="is-pulled-right">{CONTACT.address.street},<br/>{CONTACT.address.city}, {CONTACT.address.state} {CONTACT.address.zip}</span></li>
                <li>&nbsp;</li>
                <li><strong>Phone:</strong><span className="is-pulled-right"><a href={`tel:${CONTACT.phone.replace(/[^0-9]/g, '')}`}>{CONTACT.phone}</a></span></li>
                <li><strong>Email:</strong><span className="is-pulled-right"><a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a></span></li>
              </dl>
            </div>
            <div className="column is-4">
              <h5 className="title is-5">Hours</h5>
              <dl className="no-style">
                <li><strong>Sun-Thu</strong><span className="is-pulled-right">{HOURS.sunThu}</span></li>
                <li><strong>Fri</strong><span className="is-pulled-right">{HOURS.fri}</span></li>
                <li><strong>Sat</strong><span className="is-pulled-right">{HOURS.sat}</span></li>
              </dl>
            </div>
            <div className="column is-4">
              <h5 className="title is-5">Social Media</h5>
              <dl className="no-style">
                <li><strong><i className="fa fa-facebook"/> Facebook</strong><span className="is-pulled-right"><a href={SOCIAL_MEDIA.facebook}>Visit us on Facebook</a></span></li>
                <li><strong><i className="fa fa-instagram"/> Instagram</strong><span className="is-pulled-right"><a href={SOCIAL_MEDIA.instagram}>Connect on Instagram</a></span></li>
                <li><strong><i className="fa fa-twitter"/> Twitter</strong><span className="is-pulled-right"><a href={SOCIAL_MEDIA.twitter}>Tweet at us on Twitter</a></span></li>
              </dl>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
